<app-dialog
  [overlayClose]="false"
  [(visible)]="isVisible"
  width="460"
  [customVisible]="true"
  (keydown)="keydown($event)"
  [title]="'Account.ResetPasswordTitle' | translate"
  (action)="onResetPasswordDialogAction($event)"
  [isHideWhenSessionExpired]="false"
>
  <div [ngClass]="isReLogin ? 'Modal-content' : ''">
    <div innerHTML="{{ 'Account.CPRExplain' | translate: { SystemAlias: branding.SystemAlias } }}"></div>
    <app-text-edit [label]="'Account.CPR' | translate" [editMode]="true" [(value)]="cprNo"></app-text-edit>
    <app-text-edit [label]="'Account.Email' | translate" [type]="'email'" [editMode]="true" [(value)]="email">
    </app-text-edit>
  </div>
  <app-dialog-action [type]="'Cancel'"></app-dialog-action>
  <app-dialog-action [type]="'ResetPassword'"></app-dialog-action>
</app-dialog>
<app-dialog
  class="blue-dialog"
  [(visible)]="isChangePasswordSuccessDialog"
  (action)="onChangePasswordSuccessDialogAction($event)"
  [title]="'Account.ResetPasswordTitle' | translate"
  [leadingText]="'Account.SendNewPasswordMessage' | translate"
  [isHideWhenSessionExpired]="false"
>
  <app-dialog-action [type]="'Ok'"></app-dialog-action>
</app-dialog>
